// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3MNa1","header":"PatientBlock_header__2sSXb","label":"PatientBlock_label__39gaz","option":"PatientBlock_option__jf6tn"};